import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issueNavigatorLink: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.issue-navigator-link',
		defaultMessage: 'View in Issue Navigator',
		description: 'A label used for issue navigator(also known as jql search) link',
	},
	moreButtonLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.more-button-label',
		defaultMessage: 'More actions for the issue list',
		description: 'A label of the more button',
	},
	displayInformation: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.display-information',
		defaultMessage: 'Display information',
		description: 'A label of checkbox group to toggle the visibility of table columns',
	},
	assigneeColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.assignee-column-label',
		defaultMessage: 'Assignee',
		description: 'A label of checkbox to toggle the visibility of assignee column',
	},
	priorityColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.priority-column-label',
		defaultMessage: 'Priority',
		description: 'A label of checkbox to toggle the visibility of priority column',
	},
	issueStatusColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.issue-status-column-label',
		defaultMessage: 'Issue status',
		description: 'A label of checkbox to toggle the visibility of issue status column',
	},
	developmentStatusColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.development-status-column-label',
		defaultMessage: 'Development status',
		description: 'A label of checkbox to toggle the visibility of development status column',
	},
	buildStatusColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.build-status-column-label',
		defaultMessage: 'Build status',
		description: 'A label of checkbox to toggle the visibility of build status column',
	},
	deliveryStatusColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.delivery-status-column-label',
		defaultMessage: 'Delivery status',
		description: 'A label of checkbox to toggle the visibility of deployment status column',
	},
	featureFlagStatusColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.feature-flag-status-column-label',
		defaultMessage: 'Feature flag status',
		description: 'A label of checkbox to toggle the visibility of feature flag status column',
	},
	errorFlagDescription: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.error-flag-description',
		defaultMessage: "We couldn't save your preference. Please try again.",
		description: 'Flag description for failure to update version description',
	},
	moreActionColumnLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.more-action-column-label',
		defaultMessage: 'More actions',
		description: 'A label of checkbox to toggle the visibility of more actions column',
	},
	manageWarningsButtonLabel: {
		id: 'software-releases-version-detail-issue-list.issues-more-button.manage-warnings-button-label',
		defaultMessage: 'Manage warnings',
		description: 'A label of the manage warnings button',
	},
});
